import { create } from 'zustand';
import type { Message } from '../types/chat.types';

interface ChatState {
  // Messages
  messages: Message[];
  setMessages: (messages: Message[] | ((prev: Message[]) => Message[])) => void;

  // Streaming
  isStreaming: boolean;
  setIsStreaming: (streaming: boolean) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;

  // Session
  sessionExpired: boolean;
  setSessionExpired: (expired: boolean) => void;

  // Experiments — variant number keyed by feature letter (e.g. { A: 1, B: 2 })
  experiments: Record<string, number>;
  setExperiments: (experiments: Record<string, number>) => void;
  experimentsSource: 'session' | 'override' | null;
  setExperimentsSource: (source: 'session' | 'override' | null) => void;
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  setMessages: (messagesOrUpdater) =>
    set((state) => ({
      messages:
        typeof messagesOrUpdater === 'function'
          ? messagesOrUpdater(state.messages)
          : messagesOrUpdater,
    })),
  isStreaming: false,
  setIsStreaming: (streaming) => set({ isStreaming: streaming }),
  isLoading: false,
  setIsLoading: (loading) => set({ isLoading: loading }),
  sessionExpired: false,
  setSessionExpired: (expired) => set({ sessionExpired: expired }),
  experiments: {},
  setExperiments: (experiments) => set({ experiments }),
  experimentsSource: null,
  setExperimentsSource: (source) => set({ experimentsSource: source }),
}));
